import { SessionLeagueDetails } from '@/modules/league/new-components/types';
import getStandingsTable from '@/modules/league/details/standings/getStandingsTable';

interface StandingsProps {
  session: SessionLeagueDetails;
  params: { slug: string; sessionId: string };
}

export default function Standings({ session, params }: StandingsProps) {
  return getStandingsTable(session, params);
}
